import _Promise from 'babel-runtime/core-js/promise';
import _Object$keys from 'babel-runtime/core-js/object/keys';
import 'babel-runtime/core-js/json/stringify';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

var callback = function callback(_callback) {
  return {
    value: function value() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return (_callback || noop).apply(undefined, [this].concat(args));
    }
  };
};
var asyncCallback = function asyncCallback(callback) {
  return {
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', (callback || noop).apply(undefined, [this].concat(_toConsumableArray(args))));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function value() {
        return _ref.apply(this, arguments);
      }

      return value;
    }()
  };
};
var getterSetter = function getterSetter(fn) {
  return {
    get: function get() {
      return fn(this);
    },
    set: function set(value) {
      fn(this, ensureDefined(value));
    }
  };
};
var getter = function getter(fn) {
  return {
    get: function get() {
      return fn(this);
    }
  };
};

var ensureDefined = function ensureDefined(x) {
  return isDefined(x) ? x : null;
};
var isDefined = function isDefined(x) {
  return typeof x !== 'undefined';
};
var noop = function noop() {};
var toArray = function toArray(nodeList) {
  return [].slice.call(nodeList);
};
var groupBy = function groupBy(list, properties) {
  properties = Array.isArray(properties) ? properties : [properties];
  var groups = list.reduce(function (acc, item) {
    var keys = properties.map(function (p) {
      return typeof p === 'function' ? p(item) : item[p];
    });

    acc[keys] = acc[keys] || [];
    acc[keys].push(item);

    return acc;
  }, {});

  return _Object$keys(groups).map(function (key) {
    return groups[key];
  }).filter(function (n) {
    return n;
  });
};

var domReady = new _Promise(function (resolve, reject) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function handleReady() {
      document.removeEventListener('DOMContentLoaded', handleReady);
      resolve();
    });
  } else {
    resolve();
  }
});

var query = function query(element, selector) {
  return element.querySelector(selector);
};
var queryAll = function queryAll(element, selector) {
  return toArray(element.querySelectorAll(selector));
};
var tag = function tag(tagName) {
  return document.createElement(tagName);
};
var hasAttr = function hasAttr(element, attributeName) {
  return element.hasAttribute(attributeName);
};
var attr = function attr(element, attributeName, value) {
  if (isDefined(value)) {
    if (value !== null) {
      element.setAttribute(attributeName, value);
    } else {
      element.removeAttribute(attributeName);
    }
  } else {
    return element.getAttribute(attributeName);
  }
};

var on = function on(element, event, fn, capture) {
  return element.addEventListener(event, fn, capture);
};
var off = function off(element, event, fn, capture) {
  return element.removeEventListener(event, fn, capture);
};
var append = function append(element, elementToAppend, elementToAppendBefore) {
  return element.insertBefore(elementToAppend, elementToAppendBefore);
};
var remove = function remove(element) {
  return element && element.parentElement ? element.parentElement.removeChild(element) : element;
};

var removeTextNodes = function removeTextNodes(element) {
  toArray(element.childNodes).forEach(function (x) {
    if (x.nodeType === document.TEXT_NODE) {
      element.removeChild(x);
    }
  });
};

export { on as a, attr as b, hasAttr as c, off as d, callback as e, tag as f, append as g, getterSetter as h, isDefined as i, removeTextNodes as j, query as k, remove as l, noop as m, getter as n, toArray as o, queryAll as p, domReady as q, asyncCallback as r, groupBy as s };
